import React from "react";

interface PauseCircleIconProps {
  size: number;
  color?: string;
}

export default function PauseCircleIcon({
  size = 20,
  color = "#EB5757",
}: PauseCircleIconProps) {
  return (
    <div>
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 3.4375C9.1382 3.4375 8.28484 3.60724 7.48864 3.93704C6.69244 4.26684 5.969 4.75023 5.35961 5.35961C4.75023 5.969 4.26684 6.69244 3.93704 7.48864C3.60724 8.28484 3.4375 9.1382 3.4375 10C3.4375 10.8618 3.60724 11.7152 3.93704 12.5114C4.26684 13.3076 4.75023 14.031 5.35961 14.6404C5.969 15.2498 6.69244 15.7332 7.48864 16.063C8.28484 16.3928 9.1382 16.5625 10 16.5625C11.7405 16.5625 13.4097 15.8711 14.6404 14.6404C15.8711 13.4097 16.5625 11.7405 16.5625 10C16.5625 8.25952 15.8711 6.59032 14.6404 5.35961C13.4097 4.1289 11.7405 3.4375 10 3.4375ZM2.5 10C2.5 8.01088 3.29018 6.10322 4.6967 4.6967C6.10322 3.29018 8.01088 2.5 10 2.5C11.9891 2.5 13.8968 3.29018 15.3033 4.6967C16.7098 6.10322 17.5 8.01088 17.5 10C17.5 11.9891 16.7098 13.8968 15.3033 15.3033C13.8968 16.7098 11.9891 17.5 10 17.5C8.01088 17.5 6.10322 16.7098 4.6967 15.3033C3.29018 13.8968 2.5 11.9891 2.5 10ZM7.1875 8.125C7.1875 7.87636 7.28627 7.6379 7.46209 7.46209C7.6379 7.28627 7.87636 7.1875 8.125 7.1875H11.875C12.1236 7.1875 12.3621 7.28627 12.5379 7.46209C12.7137 7.6379 12.8125 7.87636 12.8125 8.125V11.875C12.8125 12.1236 12.7137 12.3621 12.5379 12.5379C12.3621 12.7137 12.1236 12.8125 11.875 12.8125H8.125C7.87636 12.8125 7.6379 12.7137 7.46209 12.5379C7.28627 12.3621 7.1875 12.1236 7.1875 11.875V8.125Z"
          fill={color}
        />
      </svg>
    </div>
  );
}
